import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

// User logged in status | boolean
const modLo = window.modLo
// Is editing page status | boolean
const isEditing = window.isEditing

function renderInstances () {
  let nodeModuleId = null
  const moduleSettings = window.moduleSettings

  for (let item in moduleSettings) {
    nodeModuleId = item
    new Vue({
      render: h => h(App, {
        props: {
          initialModuleSettings: moduleSettings[nodeModuleId],
          nodeModuleId: nodeModuleId,
          modLo: modLo,
          isEditing: isEditing
        }
      })
    }).$mount('#' + nodeModuleId)
  }
}

// Render Vue instances
renderInstances()

// Use mutationObserver to detect changes in DOM if user is logged in and editing content
if (modLo === true && isEditing === true) {
  // Beaver builder container
  var beaverContentNode = document.querySelector('.fl-builder-content')

  // detect changes in dom and re-render vue instances if custom posts feed modules are added, removed or settings are updated
  var MutationObserver = window.MutationObserver || window.WebKitMutationObserver
  var bbContainerChangeCallback = function (mutations) {
    mutations.forEach(function (mutation) {
      renderInstances()
    })
  }
  var frontEndObserver = new MutationObserver(bbContainerChangeCallback) // new instance MutationObserver for element changes in bb content container

  frontEndObserver.observe(beaverContentNode, {
    attributes: false,
    attributeOldValue: false,
    childList: true
  })
}
